import ClipApiCollection from 'collections/researchClipApiCollection'
import LivePreviewListView from 'views/agents/livePreviewListView'
import ResearchResultListController from 'controllers/research/researchResultListController'
import AutomaticAppendTracker from 'models/agents/automaticAppendTracker'
import dayjs from 'libraries/dayjs'

var LivePreviewListController = ResearchResultListController.extend({
  initialize: function (options) {
    this.listItemViews = {};
    this.clips = new ClipApiCollection([], {
      //search options
      topicBuildParameters: options.topicBuildParameters,
      sourceCategoryIds: options.sourceCategoryIds,
      sourceIdsToExclude: options.sourceIdsToExclude,
      sourceGroupIds: options.sourceGroupIds,
      since: dayjs().subtract(1, 'month').unix(),
      before: dayjs().unix()
    });

    this.view = new LivePreviewListView({
      results: this.clips,
      appendTracker: options.appendTracker
    });

    this.appendTracker = new AutomaticAppendTracker();

    this._registerListeners();

    this.appendItems();
  }
});

export default LivePreviewListController;
